import _toConsumableArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _callSuper from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function e(e, t) {
  var i = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;
    for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
  }
  return i;
}
"function" == typeof SuppressedError && SuppressedError;
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function i(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function o(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var n = o(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = function () {
    function e() {
      var e = this;
      this.locked = new Map(), this.addToLocked = function (t, i) {
        var o = e.locked.get(t);
        void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [i]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
      }, this.isLocked = function (t) {
        return e.locked.has(t);
      }, this.lock = function (t) {
        return new Promise(function (i, o) {
          e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
        });
      }, this.unlock = function (t) {
        var i = e.locked.get(t);
        if (void 0 !== i && 0 !== i.length) {
          var o = i.pop();
          e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
        } else e.locked.delete(t);
      };
    }
    return e.getInstance = function () {
      return void 0 === e.instance && (e.instance = new e()), e.instance;
    }, e;
  }();
  t.default = function () {
    return i.getInstance();
  };
});
i(n);
var a = i(o(function (e, i) {
  var o = t && t.__awaiter || function (e, t, i, o) {
      return new (i || (i = Promise))(function (n, a) {
        function r(e) {
          try {
            c(o.next(e));
          } catch (e) {
            a(e);
          }
        }
        function s(e) {
          try {
            c(o.throw(e));
          } catch (e) {
            a(e);
          }
        }
        function c(e) {
          e.done ? n(e.value) : new i(function (t) {
            t(e.value);
          }).then(r, s);
        }
        c((o = o.apply(e, t || [])).next());
      });
    },
    a = t && t.__generator || function (e, t) {
      var i,
        o,
        n,
        a,
        r = {
          label: 0,
          sent: function sent() {
            if (1 & n[0]) throw n[1];
            return n[1];
          },
          trys: [],
          ops: []
        };
      return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
        return this;
      }), a;
      function s(a) {
        return function (s) {
          return function (a) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; r;) try {
              if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
              switch (o = 0, n && (a = [2 & a[0], n.value]), a[0]) {
                case 0:
                case 1:
                  n = a;
                  break;
                case 4:
                  return r.label++, {
                    value: a[1],
                    done: !1
                  };
                case 5:
                  r.label++, o = a[1], a = [0];
                  continue;
                case 7:
                  a = r.ops.pop(), r.trys.pop();
                  continue;
                default:
                  if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                    r = 0;
                    continue;
                  }
                  if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                    r.label = a[1];
                    break;
                  }
                  if (6 === a[0] && r.label < n[1]) {
                    r.label = n[1], n = a;
                    break;
                  }
                  if (n && r.label < n[2]) {
                    r.label = n[2], r.ops.push(a);
                    break;
                  }
                  n[2] && r.ops.pop(), r.trys.pop();
                  continue;
              }
              a = t.call(e, r);
            } catch (e) {
              a = [6, e], o = 0;
            } finally {
              i = n = 0;
            }
            if (5 & a[0]) throw a[1];
            return {
              value: a[0] ? a[1] : void 0,
              done: !0
            };
          }([a, s]);
        };
      }
    },
    r = t;
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  var s = "browser-tabs-lock-key",
    c = {
      key: function key(e) {
        return o(r, void 0, void 0, function () {
          return a(this, function (e) {
            throw new Error("Unsupported");
          });
        });
      },
      getItem: function getItem(e) {
        return o(r, void 0, void 0, function () {
          return a(this, function (e) {
            throw new Error("Unsupported");
          });
        });
      },
      clear: function clear() {
        return o(r, void 0, void 0, function () {
          return a(this, function (e) {
            return [2, window.localStorage.clear()];
          });
        });
      },
      removeItem: function removeItem(e) {
        return o(r, void 0, void 0, function () {
          return a(this, function (e) {
            throw new Error("Unsupported");
          });
        });
      },
      setItem: function setItem(e, t) {
        return o(r, void 0, void 0, function () {
          return a(this, function (e) {
            throw new Error("Unsupported");
          });
        });
      },
      keySync: function keySync(e) {
        return window.localStorage.key(e);
      },
      getItemSync: function getItemSync(e) {
        return window.localStorage.getItem(e);
      },
      clearSync: function clearSync() {
        return window.localStorage.clear();
      },
      removeItemSync: function removeItemSync(e) {
        return window.localStorage.removeItem(e);
      },
      setItemSync: function setItemSync(e, t) {
        return window.localStorage.setItem(e, t);
      }
    };
  function d(e) {
    return new Promise(function (t) {
      return setTimeout(t, e);
    });
  }
  function u(e) {
    for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++) {
      i += t[Math.floor(Math.random() * t.length)];
    }
    return i;
  }
  var l = function () {
    function e(t) {
      this.acquiredIatSet = new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
    }
    return e.prototype.acquireLock = function (t, i) {
      return void 0 === i && (i = 5e3), o(this, void 0, void 0, function () {
        var o, n, r, l, h, p, m;
        return a(this, function (a) {
          switch (a.label) {
            case 0:
              o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
            case 1:
              return Date.now() < n ? [4, d(30)] : [3, 8];
            case 2:
              return a.sent(), null !== l.getItemSync(r) ? [3, 5] : (h = this.id + "-" + t + "-" + o, [4, d(Math.floor(25 * Math.random()))]);
            case 3:
              return a.sent(), l.setItemSync(r, JSON.stringify({
                id: this.id,
                iat: o,
                timeoutKey: h,
                timeAcquired: Date.now(),
                timeRefreshed: Date.now()
              })), [4, d(30)];
            case 4:
              return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [2, !0]) : [3, 7];
            case 5:
              return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [4, this.waitForSomethingToChange(n)];
            case 6:
              a.sent(), a.label = 7;
            case 7:
              return o = Date.now() + u(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, e.prototype.refreshLockWhileAcquired = function (e, t) {
      return o(this, void 0, void 0, function () {
        var i = this;
        return a(this, function (r) {
          return setTimeout(function () {
            return o(i, void 0, void 0, function () {
              var i, o, r;
              return a(this, function (a) {
                switch (a.label) {
                  case 0:
                    return [4, n.default().lock(t)];
                  case 1:
                    return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? (n.default().unlock(t), [2]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [2])) : (n.default().unlock(t), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, e.prototype.waitForSomethingToChange = function (t) {
      return o(this, void 0, void 0, function () {
        return a(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, new Promise(function (i) {
                var o = !1,
                  n = Date.now(),
                  a = !1;
                function r() {
                  if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                    o = !0;
                    var t = 50 - (Date.now() - n);
                    t > 0 ? setTimeout(i, t) : i(null);
                  }
                }
                window.addEventListener("storage", r), e.addToWaiting(r);
                var s = setTimeout(r, Math.max(0, t - Date.now()));
              })];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, e.addToWaiting = function (t) {
      this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
    }, e.removeFromWaiting = function (t) {
      void 0 !== e.waiters && (e.waiters = e.waiters.filter(function (e) {
        return e !== t;
      }));
    }, e.notifyWaiters = function () {
      void 0 !== e.waiters && e.waiters.slice().forEach(function (e) {
        return e();
      });
    }, e.prototype.releaseLock = function (e) {
      return o(this, void 0, void 0, function () {
        return a(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.releaseLock__private__(e)];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.releaseLock__private__ = function (t) {
      return o(this, void 0, void 0, function () {
        var i, o, r, d;
        return a(this, function (a) {
          switch (a.label) {
            case 0:
              return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [2] : (d = JSON.parse(r)).id !== this.id ? [3, 2] : [4, n.default().lock(d.iat)];
            case 1:
              a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, e.lockCorrector = function (t) {
      for (var i = Date.now() - 5e3, o = t, n = [], a = 0;;) {
        var r = o.keySync(a);
        if (null === r) break;
        n.push(r), a++;
      }
      for (var c = !1, d = 0; d < n.length; d++) {
        var u = n[d];
        if (u.includes(s)) {
          var l = o.getItemSync(u);
          if (null !== l) {
            var h = JSON.parse(l);
            (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
          }
        }
      }
      c && e.notifyWaiters();
    }, e.waiters = void 0, e;
  }();
  i.default = l;
}));
var r = {
    timeoutInSeconds: 60
  },
  s = {
    name: "auth0-spa-js",
    version: "2.1.3"
  },
  c = function c() {
    return Date.now();
  };
var d = /*#__PURE__*/function (_Error) {
  function d(e, t) {
    var _this;
    _classCallCheck(this, d);
    _this = _callSuper(this, d, [t]), _this.error = e, _this.error_description = t, Object.setPrototypeOf(_assertThisInitialized(_this), d.prototype);
    return _this;
  }
  _inherits(d, _Error);
  return _createClass(d, null, [{
    key: "fromPayload",
    value: function fromPayload(_ref) {
      var e = _ref.error,
        t = _ref.error_description;
      return new d(e, t);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var u = /*#__PURE__*/function (_d) {
  function u(e, t, i) {
    var _this2;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, u);
    _this2 = _callSuper(this, u, [e, t]), _this2.state = i, _this2.appState = o, Object.setPrototypeOf(_assertThisInitialized(_this2), u.prototype);
    return _this2;
  }
  _inherits(u, _d);
  return _createClass(u);
}(d);
var l = /*#__PURE__*/function (_d2) {
  function l() {
    var _this3;
    _classCallCheck(this, l);
    _this3 = _callSuper(this, l, ["timeout", "Timeout"]), Object.setPrototypeOf(_assertThisInitialized(_this3), l.prototype);
    return _this3;
  }
  _inherits(l, _d2);
  return _createClass(l);
}(d);
var h = /*#__PURE__*/function (_l) {
  function h(e) {
    var _this4;
    _classCallCheck(this, h);
    _this4 = _callSuper(this, h), _this4.popup = e, Object.setPrototypeOf(_assertThisInitialized(_this4), h.prototype);
    return _this4;
  }
  _inherits(h, _l);
  return _createClass(h);
}(l);
var p = /*#__PURE__*/function (_d3) {
  function p(e) {
    var _this5;
    _classCallCheck(this, p);
    _this5 = _callSuper(this, p, ["cancelled", "Popup closed"]), _this5.popup = e, Object.setPrototypeOf(_assertThisInitialized(_this5), p.prototype);
    return _this5;
  }
  _inherits(p, _d3);
  return _createClass(p);
}(d);
var m = /*#__PURE__*/function (_d4) {
  function m(e, t, i) {
    var _this6;
    _classCallCheck(this, m);
    _this6 = _callSuper(this, m, [e, t]), _this6.mfa_token = i, Object.setPrototypeOf(_assertThisInitialized(_this6), m.prototype);
    return _this6;
  }
  _inherits(m, _d4);
  return _createClass(m);
}(d);
var f = /*#__PURE__*/function (_d5) {
  function f(e, t) {
    var _this7;
    _classCallCheck(this, f);
    _this7 = _callSuper(this, f, ["missing_refresh_token", "Missing Refresh Token (audience: '".concat(g(e, ["default"]), "', scope: '").concat(g(t), "')")]), _this7.audience = e, _this7.scope = t, Object.setPrototypeOf(_assertThisInitialized(_this7), f.prototype);
    return _this7;
  }
  _inherits(f, _d5);
  return _createClass(f);
}(d);
function g(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return e && !t.includes(e) ? e : "";
}
var w = function w() {
    return window.crypto;
  },
  y = function y() {
    var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    var t = "";
    return Array.from(w().getRandomValues(new Uint8Array(43))).forEach(function (i) {
      return t += e[i % e.length];
    }), t;
  },
  k = function k(e) {
    return btoa(e);
  },
  v = function v(t) {
    var i = t.clientId,
      o = e(t, ["clientId"]);
    return new URLSearchParams(function (e) {
      return Object.keys(e).filter(function (t) {
        return void 0 !== e[t];
      }).reduce(function (t, i) {
        return Object.assign(Object.assign({}, t), _defineProperty({}, i, e[i]));
      }, {});
    }(Object.assign({
      client_id: i
    }, o))).toString();
  },
  b = function b(e) {
    return function (e) {
      return decodeURIComponent(atob(e).split("").map(function (e) {
        return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }(e.replace(/_/g, "/").replace(/-/g, "+"));
  },
  _ = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t) {
      var i;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(e, t);
          case 2:
            i = _context.sent;
            _context.t0 = i.ok;
            _context.next = 6;
            return i.json();
          case 6:
            _context.t1 = _context.sent;
            return _context.abrupt("return", {
              ok: _context.t0,
              json: _context.t1
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(),
  I = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, t, i) {
      var o, n;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            o = new AbortController();
            return _context2.abrupt("return", (t.signal = o.signal, Promise.race([_(e, t), new Promise(function (e, t) {
              n = setTimeout(function () {
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
              }, i);
            })]).finally(function () {
              clearTimeout(n);
            })));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function I(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }(),
  S = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, t, i, o, n, a, r) {
      var s, c;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (s = {
              auth: {
                audience: t,
                scope: i
              },
              timeout: n,
              fetchUrl: e,
              fetchOptions: o,
              useFormData: r
            }, c = a, new Promise(function (e, t) {
              var i = new MessageChannel();
              i.port1.onmessage = function (o) {
                o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
              }, c.postMessage(s, [i.port2]);
            })));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function S(_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }(),
  O = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e, t, i, o, n, a) {
      var r,
        _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            r = _args4.length > 6 && _args4[6] !== undefined ? _args4[6] : 1e4;
            return _context4.abrupt("return", n ? S(e, t, i, o, r, n, a) : I(e, o, r));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function O(_x13, _x14, _x15, _x16, _x17, _x18) {
      return _ref5.apply(this, arguments);
    };
  }();
function T(_x19, _x20) {
  return _T.apply(this, arguments);
}
function _T() {
  _T = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(t, i) {
    var o, n, a, r, c, u, l, h;
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          o = t.baseUrl, n = t.timeout, a = t.audience, r = t.scope, c = t.auth0Client, u = t.useFormData, l = e(t, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
          h = u ? v(l) : JSON.stringify(l);
          _context38.next = 4;
          return function () {
            var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(t, i, o, n, a, r, s) {
              var c, u, _e8, l, h, p, g, _c, w, _e9;
              return _regeneratorRuntime().wrap(function _callee37$(_context37) {
                while (1) switch (_context37.prev = _context37.next) {
                  case 0:
                    u = null;
                    _e8 = 0;
                  case 2:
                    if (!(_e8 < 3)) {
                      _context37.next = 17;
                      break;
                    }
                    _context37.prev = 3;
                    _context37.next = 6;
                    return O(t, o, n, a, r, s, i);
                  case 6:
                    c = _context37.sent;
                    u = null;
                    return _context37.abrupt("break", 17);
                  case 11:
                    _context37.prev = 11;
                    _context37.t0 = _context37["catch"](3);
                    u = _context37.t0;
                  case 14:
                    _e8++;
                    _context37.next = 2;
                    break;
                  case 17:
                    if (!u) {
                      _context37.next = 19;
                      break;
                    }
                    throw u;
                  case 19:
                    l = c.json, h = l.error, p = l.error_description, g = e(l, ["error", "error_description"]), _c = c, w = _c.ok;
                    if (w) {
                      _context37.next = 27;
                      break;
                    }
                    _e9 = p || "HTTP error. Unable to fetch ".concat(t);
                    if (!("mfa_required" === h)) {
                      _context37.next = 24;
                      break;
                    }
                    throw new m(h, _e9, g.mfa_token);
                  case 24:
                    if (!("missing_refresh_token" === h)) {
                      _context37.next = 26;
                      break;
                    }
                    throw new f(o, n);
                  case 26:
                    throw new d(h || "request_error", _e9);
                  case 27:
                    return _context37.abrupt("return", g);
                  case 28:
                  case "end":
                    return _context37.stop();
                }
              }, _callee37, null, [[3, 11]]);
            }));
            return function (_x53, _x54, _x55, _x56, _x57, _x58, _x59) {
              return _ref13.apply(this, arguments);
            };
          }()("".concat(o, "/oauth/token"), n, a || "default", r, {
            method: "POST",
            body: h,
            headers: {
              "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
              "Auth0-Client": btoa(JSON.stringify(c || s))
            }
          }, i, u);
        case 4:
          return _context38.abrupt("return", _context38.sent);
        case 5:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _T.apply(this, arguments);
}
var j = function j() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
  var t;
};
var C = /*#__PURE__*/function () {
  function C(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "@@auth0spajs@@";
    var i = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, C);
    this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
  }
  return _createClass(C, [{
    key: "toKey",
    value: function toKey() {
      return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
    }
  }], [{
    key: "fromKey",
    value: function fromKey(e) {
      var _e$split = e.split("::"),
        _e$split2 = _slicedToArray(_e$split, 4),
        t = _e$split2[0],
        i = _e$split2[1],
        o = _e$split2[2],
        n = _e$split2[3];
      return new C({
        clientId: i,
        scope: n,
        audience: o
      }, t);
    }
  }, {
    key: "fromCacheEntry",
    value: function fromCacheEntry(e) {
      var t = e.scope,
        i = e.audience,
        o = e.client_id;
      return new C({
        scope: t,
        audience: i,
        clientId: o
      });
    }
  }]);
}();
var z = /*#__PURE__*/function () {
  function z() {
    _classCallCheck(this, z);
  }
  return _createClass(z, [{
    key: "set",
    value: function set(e, t) {
      localStorage.setItem(e, JSON.stringify(t));
    }
  }, {
    key: "get",
    value: function get(e) {
      var t = window.localStorage.getItem(e);
      if (t) try {
        return JSON.parse(t);
      } catch (e) {
        return;
      }
    }
  }, {
    key: "remove",
    value: function remove(e) {
      localStorage.removeItem(e);
    }
  }, {
    key: "allKeys",
    value: function allKeys() {
      return Object.keys(window.localStorage).filter(function (e) {
        return e.startsWith("@@auth0spajs@@");
      });
    }
  }]);
}();
var P = /*#__PURE__*/_createClass(function P() {
  _classCallCheck(this, P);
  this.enclosedCache = function () {
    var e = {};
    return {
      set: function set(t, i) {
        e[t] = i;
      },
      get: function get(t) {
        var i = e[t];
        if (i) return i;
      },
      remove: function remove(t) {
        delete e[t];
      },
      allKeys: function allKeys() {
        return Object.keys(e);
      }
    };
  }();
});
var x = /*#__PURE__*/function () {
  function x(e, t, i) {
    _classCallCheck(this, x);
    this.cache = e, this.keyManifest = t, this.nowProvider = i || c;
  }
  return _createClass(x, [{
    key: "setIdToken",
    value: function () {
      var _setIdToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e, t, i) {
        var o, n;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              n = this.getIdTokenCacheKey(e);
              _context5.next = 3;
              return this.cache.set(n, {
                id_token: t,
                decodedToken: i
              });
            case 3:
              _context5.next = 5;
              return null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setIdToken(_x21, _x22, _x23) {
        return _setIdToken.apply(this, arguments);
      }
      return setIdToken;
    }()
  }, {
    key: "getIdToken",
    value: function () {
      var _getIdToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        var t, _t;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.cache.get(this.getIdTokenCacheKey(e.clientId));
            case 2:
              t = _context6.sent;
              if (!(!t && e.scope && e.audience)) {
                _context6.next = 12;
                break;
              }
              _context6.next = 6;
              return this.get(e);
            case 6:
              _t = _context6.sent;
              if (_t) {
                _context6.next = 9;
                break;
              }
              return _context6.abrupt("return");
            case 9:
              if (!(!_t.id_token || !_t.decodedToken)) {
                _context6.next = 11;
                break;
              }
              return _context6.abrupt("return");
            case 11:
              return _context6.abrupt("return", {
                id_token: _t.id_token,
                decodedToken: _t.decodedToken
              });
            case 12:
              if (!t) {
                _context6.next = 14;
                break;
              }
              return _context6.abrupt("return", {
                id_token: t.id_token,
                decodedToken: t.decodedToken
              });
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getIdToken(_x24) {
        return _getIdToken.apply(this, arguments);
      }
      return getIdToken;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
        var t,
          i,
          o,
          _t2,
          _i,
          n,
          a,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              t = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 0;
              _context7.next = 3;
              return this.cache.get(e.toKey());
            case 3:
              o = _context7.sent;
              if (o) {
                _context7.next = 16;
                break;
              }
              _context7.next = 7;
              return this.getCacheKeys();
            case 7:
              _t2 = _context7.sent;
              if (_t2) {
                _context7.next = 10;
                break;
              }
              return _context7.abrupt("return");
            case 10:
              _i = this.matchExistingCacheKey(e, _t2);
              _context7.t0 = _i;
              if (!_context7.t0) {
                _context7.next = 16;
                break;
              }
              _context7.next = 15;
              return this.cache.get(_i);
            case 15:
              o = _context7.sent;
            case 16:
              if (o) {
                _context7.next = 18;
                break;
              }
              return _context7.abrupt("return");
            case 18:
              _context7.next = 20;
              return this.nowProvider();
            case 20:
              n = _context7.sent;
              a = Math.floor(n / 1e3);
              if (!(o.expiresAt - t < a)) {
                _context7.next = 38;
                break;
              }
              if (!o.body.refresh_token) {
                _context7.next = 30;
                break;
              }
              o.body = {
                refresh_token: o.body.refresh_token
              };
              _context7.next = 27;
              return this.cache.set(e.toKey(), o);
            case 27:
              _context7.t2 = o.body;
              _context7.next = 35;
              break;
            case 30:
              _context7.next = 32;
              return this.cache.remove(e.toKey());
            case 32:
              _context7.next = 34;
              return null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey());
            case 34:
              _context7.t2 = void _context7.sent;
            case 35:
              _context7.t1 = _context7.t2;
              _context7.next = 39;
              break;
            case 38:
              _context7.t1 = o.body;
            case 39:
              return _context7.abrupt("return", _context7.t1);
            case 40:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function get(_x25) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        var t, i, o;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              i = new C({
                clientId: e.client_id,
                scope: e.scope,
                audience: e.audience
              });
              _context8.next = 3;
              return this.wrapCacheEntry(e);
            case 3:
              o = _context8.sent;
              _context8.next = 6;
              return this.cache.set(i.toKey(), o);
            case 6:
              _context8.next = 8;
              return null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey());
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function set(_x26) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
        var _this8 = this;
        var t, i;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.getCacheKeys();
            case 2:
              i = _context10.sent;
              _context10.t0 = i;
              if (!_context10.t0) {
                _context10.next = 9;
                break;
              }
              _context10.next = 7;
              return i.filter(function (t) {
                return !e || t.includes(e);
              }).reduce(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e, t) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return e;
                      case 2:
                        _context9.next = 4;
                        return _this8.cache.remove(t);
                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x28, _x29) {
                  return _ref6.apply(this, arguments);
                };
              }(), Promise.resolve());
            case 7:
              _context10.next = 9;
              return null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear();
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function clear(_x27) {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
  }, {
    key: "wrapCacheEntry",
    value: function () {
      var _wrapCacheEntry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.nowProvider();
            case 2:
              t = _context11.sent;
              return _context11.abrupt("return", {
                body: e,
                expiresAt: Math.floor(t / 1e3) + e.expires_in
              });
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function wrapCacheEntry(_x30) {
        return _wrapCacheEntry.apply(this, arguments);
      }
      return wrapCacheEntry;
    }()
  }, {
    key: "getCacheKeys",
    value: function () {
      var _getCacheKeys = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var e;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!this.keyManifest) {
                _context12.next = 15;
                break;
              }
              _context12.next = 3;
              return this.keyManifest.get();
            case 3:
              _context12.t2 = e = _context12.sent;
              _context12.t1 = null === _context12.t2;
              if (_context12.t1) {
                _context12.next = 7;
                break;
              }
              _context12.t1 = void 0 === e;
            case 7:
              if (!_context12.t1) {
                _context12.next = 11;
                break;
              }
              _context12.t3 = void 0;
              _context12.next = 12;
              break;
            case 11:
              _context12.t3 = e.keys;
            case 12:
              _context12.t0 = _context12.t3;
              _context12.next = 16;
              break;
            case 15:
              _context12.t0 = this.cache.allKeys ? this.cache.allKeys() : void 0;
            case 16:
              return _context12.abrupt("return", _context12.t0);
            case 17:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getCacheKeys() {
        return _getCacheKeys.apply(this, arguments);
      }
      return getCacheKeys;
    }()
  }, {
    key: "getIdTokenCacheKey",
    value: function getIdTokenCacheKey(e) {
      return new C({
        clientId: e
      }, "@@auth0spajs@@", "@@user@@").toKey();
    }
  }, {
    key: "matchExistingCacheKey",
    value: function matchExistingCacheKey(e, t) {
      return t.filter(function (t) {
        var i;
        var o = C.fromKey(t),
          n = new Set(o.scope && o.scope.split(" ")),
          a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [],
          r = o.scope && a.reduce(function (e, t) {
            return e && n.has(t);
          }, !0);
        return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
      })[0];
    }
  }]);
}();
var Z = /*#__PURE__*/function () {
  function Z(e, t, i) {
    _classCallCheck(this, Z);
    this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = "a0.spajs.txs.".concat(this.clientId);
  }
  return _createClass(Z, [{
    key: "create",
    value: function create(e) {
      this.storage.save(this.storageKey, e, {
        daysUntilExpire: 1,
        cookieDomain: this.cookieDomain
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.storage.get(this.storageKey);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.storage.remove(this.storageKey, {
        cookieDomain: this.cookieDomain
      });
    }
  }]);
}();
var K = function K(e) {
    return "number" == typeof e;
  },
  W = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"],
  E = function E(e) {
    if (!e.id_token) throw new Error("ID token is required but missing");
    var t = function (e) {
      var t = e.split("."),
        _t3 = _slicedToArray(t, 3),
        i = _t3[0],
        o = _t3[1],
        n = _t3[2];
      if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
      var a = JSON.parse(b(o)),
        r = {
          __raw: e
        },
        s = {};
      return Object.keys(a).forEach(function (e) {
        r[e] = a[e], W.includes(e) || (s[e] = a[e]);
      }), {
        encoded: {
          header: i,
          payload: o,
          signature: n
        },
        header: JSON.parse(b(i)),
        claims: r,
        user: s
      };
    }(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error("Issuer (iss) claim mismatch in the ID token; expected \"".concat(e.iss, "\", found \"").concat(t.claims.iss, "\""));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error("Signature algorithm of \"".concat(t.header.alg, "\" is not supported. Expected the ID token to be signed with \"RS256\"."));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
      if (!t.claims.aud.includes(e.aud)) throw new Error("Audience (aud) claim mismatch in the ID token; expected \"".concat(e.aud, "\" but was not one of \"").concat(t.claims.aud.join(", "), "\""));
      if (t.claims.aud.length > 1) {
        if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
        if (t.claims.azp !== e.aud) throw new Error("Authorized Party (azp) claim mismatch in the ID token; expected \"".concat(e.aud, "\", found \"").concat(t.claims.azp, "\""));
      }
    } else if (t.claims.aud !== e.aud) throw new Error("Audience (aud) claim mismatch in the ID token; expected \"".concat(e.aud, "\" but found \"").concat(t.claims.aud, "\""));
    if (e.nonce) {
      if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
      if (t.claims.nonce !== e.nonce) throw new Error("Nonce (nonce) claim mismatch in the ID token; expected \"".concat(e.nonce, "\", found \"").concat(t.claims.nonce, "\""));
    }
    if (e.max_age && !K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    var i = e.leeway || 60,
      o = new Date(e.now || Date.now()),
      n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(o, ") is after expiration time (").concat(n, ")"));
    if (null != t.claims.nbf && K(t.claims.nbf)) {
      var _e = new Date(0);
      if (_e.setUTCSeconds(t.claims.nbf - i), o < _e) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(o, ") is before ").concat(_e));
    }
    if (null != t.claims.auth_time && K(t.claims.auth_time)) {
      var _n = new Date(0);
      if (_n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > _n) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(o, ") is after last auth at ").concat(_n));
    }
    if (e.organization) {
      var _i2 = e.organization.trim();
      if (_i2.startsWith("org_")) {
        var _e2 = _i2;
        if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
        if (_e2 !== t.claims.org_id) throw new Error("Organization ID (org_id) claim mismatch in the ID token; expected \"".concat(_e2, "\", found \"").concat(t.claims.org_id, "\""));
      } else {
        var _e3 = _i2.toLowerCase();
        if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
        if (_e3 !== t.claims.org_name) throw new Error("Organization Name (org_name) claim mismatch in the ID token; expected \"".concat(_e3, "\", found \"").concat(t.claims.org_name, "\""));
      }
    }
    return t;
  };
var R = o(function (e, i) {
  var o = t && t.__assign || function () {
    return o = Object.assign || function (e) {
      for (var t, i = 1, o = arguments.length; i < o; i++) for (var n in t = arguments[i]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      return e;
    }, o.apply(this, arguments);
  };
  function n(e, t) {
    if (!t) return "";
    var i = "; " + e;
    return !0 === t ? i : i + "=" + t;
  }
  function a(e, t, i) {
    return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function (e) {
      if ("number" == typeof e.expires) {
        var t = new Date();
        t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
      }
      return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
    }(i);
  }
  function r(e) {
    for (var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++) {
      var a = i[n].split("="),
        r = a.slice(1).join("=");
      '"' === r.charAt(0) && (r = r.slice(1, -1));
      try {
        t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
      } catch (e) {}
    }
    return t;
  }
  function s() {
    return r(document.cookie);
  }
  function c(e, t, i) {
    document.cookie = a(e, t, o({
      path: "/"
    }, i));
  }
  i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function (e) {
    return s()[e];
  }, i.set = c, i.remove = function (e, t) {
    c(e, "", o(o({}, t), {
      expires: -1
    }));
  };
});
i(R), R.encode, R.parse, R.getAll;
var U = R.get,
  L = R.set,
  D = R.remove;
var X = {
    get: function get(e) {
      var t = U(e);
      if (void 0 !== t) return JSON.parse(t);
    },
    save: function save(e, t, i) {
      var o = {};
      "https:" === window.location.protocol && (o = {
        secure: !0,
        sameSite: "none"
      }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), L(e, JSON.stringify(t), o);
    },
    remove: function remove(e, t) {
      var i = {};
      (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), D(e, i);
    }
  },
  N = {
    get: function get(e) {
      var t = X.get(e);
      return t || X.get("_legacy_".concat(e));
    },
    save: function save(e, t, i) {
      var o = {};
      "https:" === window.location.protocol && (o = {
        secure: !0
      }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), L("_legacy_".concat(e), JSON.stringify(t), o), X.save(e, t, i);
    },
    remove: function remove(e, t) {
      var i = {};
      (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), D(e, i), X.remove(e, t), X.remove("_legacy_".concat(e), t);
    }
  },
  J = {
    get: function get(e) {
      if ("undefined" == typeof sessionStorage) return;
      var t = sessionStorage.getItem(e);
      return null != t ? JSON.parse(t) : void 0;
    },
    save: function save(e, t) {
      sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove: function remove(e) {
      sessionStorage.removeItem(e);
    }
  };
function F(e, t, i) {
  var o = void 0 === t ? null : t,
    n = function (e, t) {
      var i = atob(e);
      if (t) {
        for (var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n) o[n] = i.charCodeAt(n);
        return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
      }
      return i;
    }(e, void 0 !== i && i),
    a = n.indexOf("\n", 10) + 1,
    r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""),
    s = new Blob([r], {
      type: "application/javascript"
    });
  return URL.createObjectURL(s);
}
var H,
  Y,
  G,
  V,
  M = (H = "Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwohZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7Y2xhc3MgZSBleHRlbmRzIEVycm9ye2NvbnN0cnVjdG9yKHQscil7c3VwZXIociksdGhpcy5lcnJvcj10LHRoaXMuZXJyb3JfZGVzY3JpcHRpb249cixPYmplY3Quc2V0UHJvdG90eXBlT2YodGhpcyxlLnByb3RvdHlwZSl9c3RhdGljIGZyb21QYXlsb2FkKHtlcnJvcjp0LGVycm9yX2Rlc2NyaXB0aW9uOnJ9KXtyZXR1cm4gbmV3IGUodCxyKX19Y2xhc3MgdCBleHRlbmRzIGV7Y29uc3RydWN0b3IoZSxzKXtzdXBlcigibWlzc2luZ19yZWZyZXNoX3Rva2VuIixgTWlzc2luZyBSZWZyZXNoIFRva2VuIChhdWRpZW5jZTogJyR7cihlLFsiZGVmYXVsdCJdKX0nLCBzY29wZTogJyR7cihzKX0nKWApLHRoaXMuYXVkaWVuY2U9ZSx0aGlzLnNjb3BlPXMsT2JqZWN0LnNldFByb3RvdHlwZU9mKHRoaXMsdC5wcm90b3R5cGUpfX1mdW5jdGlvbiByKGUsdD1bXSl7cmV0dXJuIGUmJiF0LmluY2x1ZGVzKGUpP2U6IiJ9ImZ1bmN0aW9uIj09dHlwZW9mIFN1cHByZXNzZWRFcnJvciYmU3VwcHJlc3NlZEVycm9yO2NvbnN0IHM9ZT0+e3ZhcntjbGllbnRJZDp0fT1lLHI9ZnVuY3Rpb24oZSx0KXt2YXIgcj17fTtmb3IodmFyIHMgaW4gZSlPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoZSxzKSYmdC5pbmRleE9mKHMpPDAmJihyW3NdPWVbc10pO2lmKG51bGwhPWUmJiJmdW5jdGlvbiI9PXR5cGVvZiBPYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzKXt2YXIgbz0wO2ZvcihzPU9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHMoZSk7bzxzLmxlbmd0aDtvKyspdC5pbmRleE9mKHNbb10pPDAmJk9iamVjdC5wcm90b3R5cGUucHJvcGVydHlJc0VudW1lcmFibGUuY2FsbChlLHNbb10pJiYocltzW29dXT1lW3Nbb11dKX1yZXR1cm4gcn0oZSxbImNsaWVudElkIl0pO3JldHVybiBuZXcgVVJMU2VhcmNoUGFyYW1zKChlPT5PYmplY3Qua2V5cyhlKS5maWx0ZXIoKHQ9PnZvaWQgMCE9PWVbdF0pKS5yZWR1Y2UoKCh0LHIpPT5PYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30sdCkse1tyXTplW3JdfSkpLHt9KSkoT2JqZWN0LmFzc2lnbih7Y2xpZW50X2lkOnR9LHIpKSkudG9TdHJpbmcoKX07bGV0IG89e307Y29uc3Qgbj0oZSx0KT0+YCR7ZX18JHt0fWA7YWRkRXZlbnRMaXN0ZW5lcigibWVzc2FnZSIsKGFzeW5jKHtkYXRhOnt0aW1lb3V0OmUsYXV0aDpyLGZldGNoVXJsOmksZmV0Y2hPcHRpb25zOmMsdXNlRm9ybURhdGE6YX0scG9ydHM6W3BdfSk9PntsZXQgZjtjb25zdHthdWRpZW5jZTp1LHNjb3BlOmx9PXJ8fHt9O3RyeXtjb25zdCByPWE/KGU9Pntjb25zdCB0PW5ldyBVUkxTZWFyY2hQYXJhbXMoZSkscj17fTtyZXR1cm4gdC5mb3JFYWNoKCgoZSx0KT0+e3JbdF09ZX0pKSxyfSkoYy5ib2R5KTpKU09OLnBhcnNlKGMuYm9keSk7aWYoIXIucmVmcmVzaF90b2tlbiYmInJlZnJlc2hfdG9rZW4iPT09ci5ncmFudF90eXBlKXtjb25zdCBlPSgoZSx0KT0+b1tuKGUsdCldKSh1LGwpO2lmKCFlKXRocm93IG5ldyB0KHUsbCk7Yy5ib2R5PWE/cyhPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKTpKU09OLnN0cmluZ2lmeShPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKX1sZXQgaCxnOyJmdW5jdGlvbiI9PXR5cGVvZiBBYm9ydENvbnRyb2xsZXImJihoPW5ldyBBYm9ydENvbnRyb2xsZXIsYy5zaWduYWw9aC5zaWduYWwpO3RyeXtnPWF3YWl0IFByb21pc2UucmFjZShbKGQ9ZSxuZXcgUHJvbWlzZSgoZT0+c2V0VGltZW91dChlLGQpKSkpLGZldGNoKGksT2JqZWN0LmFzc2lnbih7fSxjKSldKX1jYXRjaChlKXtyZXR1cm4gdm9pZCBwLnBvc3RNZXNzYWdlKHtlcnJvcjplLm1lc3NhZ2V9KX1pZighZylyZXR1cm4gaCYmaC5hYm9ydCgpLHZvaWQgcC5wb3N0TWVzc2FnZSh7ZXJyb3I6IlRpbWVvdXQgd2hlbiBleGVjdXRpbmcgJ2ZldGNoJyJ9KTtmPWF3YWl0IGcuanNvbigpLGYucmVmcmVzaF90b2tlbj8oKChlLHQscik9PntvW24odCxyKV09ZX0pKGYucmVmcmVzaF90b2tlbix1LGwpLGRlbGV0ZSBmLnJlZnJlc2hfdG9rZW4pOigoZSx0KT0+e2RlbGV0ZSBvW24oZSx0KV19KSh1LGwpLHAucG9zdE1lc3NhZ2Uoe29rOmcub2ssanNvbjpmfSl9Y2F0Y2goZSl7cC5wb3N0TWVzc2FnZSh7b2s6ITEsanNvbjp7ZXJyb3I6ZS5lcnJvcixlcnJvcl9kZXNjcmlwdGlvbjplLm1lc3NhZ2V9fSl9dmFyIGR9KSl9KCk7Cgo=", Y = null, G = !1, function (e) {
    return V = V || F(H, Y, G), new Worker(V, e);
  });
var A = {};
var B = /*#__PURE__*/function () {
  function B(e, t) {
    _classCallCheck(this, B);
    this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  return _createClass(B, [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(e) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.t0 = Set;
              _context13.next = 3;
              return this.cache.get(this.manifestKey);
            case 3:
              _context13.t3 = t = _context13.sent;
              _context13.t2 = null === _context13.t3;
              if (_context13.t2) {
                _context13.next = 7;
                break;
              }
              _context13.t2 = void 0 === t;
            case 7:
              if (!_context13.t2) {
                _context13.next = 11;
                break;
              }
              _context13.t4 = void 0;
              _context13.next = 12;
              break;
            case 11:
              _context13.t4 = t.keys;
            case 12:
              _context13.t1 = _context13.t4;
              if (_context13.t1) {
                _context13.next = 15;
                break;
              }
              _context13.t1 = [];
            case 15:
              _context13.t5 = _context13.t1;
              i = new _context13.t0(_context13.t5);
              i.add(e);
              _context13.next = 20;
              return this.cache.set(this.manifestKey, {
                keys: _toConsumableArray(i)
              });
            case 20:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function add(_x31) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(e) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.cache.get(this.manifestKey);
            case 2:
              t = _context14.sent;
              if (!t) {
                _context14.next = 16;
                break;
              }
              i = new Set(t.keys);
              i.delete(e);
              if (!(i.size > 0)) {
                _context14.next = 12;
                break;
              }
              _context14.next = 9;
              return this.cache.set(this.manifestKey, {
                keys: _toConsumableArray(i)
              });
            case 9:
              _context14.t0 = _context14.sent;
              _context14.next = 15;
              break;
            case 12:
              _context14.next = 14;
              return this.cache.remove(this.manifestKey);
            case 14:
              _context14.t0 = _context14.sent;
            case 15:
              return _context14.abrupt("return", _context14.t0);
            case 16:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function remove(_x32) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "get",
    value: function get() {
      return this.cache.get(this.manifestKey);
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.cache.remove(this.manifestKey);
    }
  }, {
    key: "createManifestKeyFrom",
    value: function createManifestKeyFrom(e) {
      return "@@auth0spajs@@::".concat(e);
    }
  }]);
}();
var $ = {
    memory: function memory() {
      return new P().enclosedCache;
    },
    localstorage: function localstorage() {
      return new z();
    }
  },
  q = function q(e) {
    return $[e];
  },
  Q = function Q(t) {
    var i = t.openUrl,
      o = t.onRedirect,
      n = e(t, ["openUrl", "onRedirect"]);
    return Object.assign(Object.assign({}, n), {
      openUrl: !1 === i || i ? i : o
    });
  },
  ee = new a();
var te = /*#__PURE__*/function () {
  function te(e) {
    var _this9 = this;
    _classCallCheck(this, te);
    var t, i;
    if (this.userCache = new P().enclosedCache, this.defaultOptions = {
      authorizationParams: {
        scope: "openid profile email"
      },
      useRefreshTokensFallback: !1,
      useFormData: !0
    }, this._releaseLockOnPageHide = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return ee.releaseLock("auth0.lock.getTokenSilently");
          case 2:
            window.removeEventListener("pagehide", _this9._releaseLockOnPageHide);
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    })), this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
      authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
    }), "undefined" != typeof window && function () {
      if (!w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (void 0 === w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
    }(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;else {
      if (t = e.cacheLocation || "memory", !q(t)) throw new Error("Invalid cache location \"".concat(t, "\""));
      i = q(t)();
    }
    this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? X : N, this.orgHintCookieName = "auth0.".concat(this.options.clientId, ".organization_hint"), this.isAuthenticatedCookieName = function (e) {
      return "auth0.".concat(e, ".is.authenticated");
    }(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
    var o = e.useCookiesForTransactions ? this.cookieStorage : J;
    var n;
    this.scope = j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || c, this.cacheManager = new x(i, i.allKeys ? void 0 : new B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : "https://".concat(n)), this.tokenIssuer = function (e, t) {
      return e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/");
    }(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new M());
  }
  return _createClass(te, [{
    key: "_url",
    value: function _url(e) {
      var t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || s)));
      return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(t);
    }
  }, {
    key: "_authorizeUrl",
    value: function _authorizeUrl(e) {
      return this._url("/authorize?".concat(v(e)));
    }
  }, {
    key: "_verifyIdToken",
    value: function () {
      var _verifyIdToken2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e, t, i) {
        var o, n;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.nowProvider();
            case 2:
              o = _context16.sent;
              return _context16.abrupt("return", E({
                iss: this.tokenIssuer,
                aud: this.options.clientId,
                id_token: e,
                nonce: t,
                organization: i,
                leeway: this.options.leeway,
                max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
                now: o
              }));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function _verifyIdToken(_x33, _x34, _x35) {
        return _verifyIdToken2.apply(this, arguments);
      }
      return _verifyIdToken;
    }()
  }, {
    key: "_processOrgHint",
    value: function _processOrgHint(e) {
      e ? this.cookieStorage.save(this.orgHintCookieName, e, {
        daysUntilExpire: this.sessionCheckExpiryDays,
        cookieDomain: this.options.cookieDomain
      }) : this.cookieStorage.remove(this.orgHintCookieName, {
        cookieDomain: this.options.cookieDomain
      });
    }
  }, {
    key: "_prepareAuthorizeUrl",
    value: function () {
      var _prepareAuthorizeUrl2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(e, t, i) {
        var o, n, a, r, s, c;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              o = k(y());
              n = k(y());
              a = y();
              _context18.t0 = function (e) {
                var t = new Uint8Array(e);
                return function (e) {
                  var t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                  };
                  return e.replace(/[+/=]/g, function (e) {
                    return t[e];
                  });
                }(window.btoa(String.fromCharCode.apply(String, _toConsumableArray(Array.from(t)))));
              };
              _context18.next = 6;
              return function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(e) {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        t = w().subtle.digest({
                          name: "SHA-256"
                        }, new TextEncoder().encode(e));
                        _context17.next = 3;
                        return t;
                      case 3:
                        return _context17.abrupt("return", _context17.sent);
                      case 4:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                return function (_x39) {
                  return _ref8.apply(this, arguments);
                };
              }()(a);
            case 6:
              _context18.t1 = _context18.sent;
              r = (0, _context18.t0)(_context18.t1);
              s = function (e, t, i, o, n, a, r, s) {
                return Object.assign(Object.assign(Object.assign({
                  client_id: e.clientId
                }, e.authorizationParams), i), {
                  scope: j(t, i.scope),
                  response_type: "code",
                  response_mode: s || "query",
                  state: o,
                  nonce: n,
                  redirect_uri: r || e.authorizationParams.redirect_uri,
                  code_challenge: a,
                  code_challenge_method: "S256"
                });
              }(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode);
              c = this._authorizeUrl(s);
              return _context18.abrupt("return", {
                nonce: n,
                code_verifier: a,
                scope: s.scope,
                audience: s.audience || "default",
                redirect_uri: s.redirect_uri,
                state: o,
                url: c
              });
            case 11:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function _prepareAuthorizeUrl(_x36, _x37, _x38) {
        return _prepareAuthorizeUrl2.apply(this, arguments);
      }
      return _prepareAuthorizeUrl;
    }()
  }, {
    key: "loginWithPopup",
    value: function () {
      var _loginWithPopup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(e, t) {
        var i, o, n, a;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(e = e || {}, !(t = t || {}).popup && (t.popup = function (e) {
                var t = window.screenX + (window.innerWidth - 400) / 2,
                  i = window.screenY + (window.innerHeight - 600) / 2;
                return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(i, ",width=400,height=600,resizable,scrollbars=yes,status=1"));
              }(""), !t.popup))) {
                _context19.next = 2;
                break;
              }
              throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
            case 2:
              _context19.next = 4;
              return this._prepareAuthorizeUrl(e.authorizationParams || {}, {
                response_mode: "web_message"
              }, window.location.origin);
            case 4:
              o = _context19.sent;
              t.popup.location.href = o.url;
              _context19.next = 8;
              return function (e) {
                return new Promise(function (t, i) {
                  var _o;
                  var n = setInterval(function () {
                      e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", _o, !1), i(new p(e.popup)));
                    }, 1e3),
                    a = setTimeout(function () {
                      clearInterval(n), i(new h(e.popup)), window.removeEventListener("message", _o, !1);
                    }, 1e3 * (e.timeoutInSeconds || 60));
                  _o = function o(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                      if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", _o, !1), e.popup.close(), r.data.response.error) return i(d.fromPayload(r.data.response));
                      t(r.data.response);
                    }
                  }, window.addEventListener("message", _o);
                });
              }(Object.assign(Object.assign({}, t), {
                timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
              }));
            case 8:
              n = _context19.sent;
              if (!(o.state !== n.state)) {
                _context19.next = 11;
                break;
              }
              throw new d("state_mismatch", "Invalid state");
            case 11:
              a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
              _context19.next = 14;
              return this._requestToken({
                audience: o.audience,
                scope: o.scope,
                code_verifier: o.code_verifier,
                grant_type: "authorization_code",
                code: n.code,
                redirect_uri: o.redirect_uri
              }, {
                nonceIn: o.nonce,
                organization: a
              });
            case 14:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function loginWithPopup(_x40, _x41) {
        return _loginWithPopup.apply(this, arguments);
      }
      return loginWithPopup;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this._getIdTokenFromCache();
            case 2:
              t = _context20.sent;
              return _context20.abrupt("return", null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user);
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
  }, {
    key: "getIdTokenClaims",
    value: function () {
      var _getIdTokenClaims = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this._getIdTokenFromCache();
            case 2:
              t = _context21.sent;
              return _context21.abrupt("return", null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims);
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getIdTokenClaims() {
        return _getIdTokenClaims.apply(this, arguments);
      }
      return getIdTokenClaims;
    }()
  }, {
    key: "loginWithRedirect",
    value: function () {
      var _loginWithRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var t,
          i,
          o,
          n,
          a,
          r,
          s,
          c,
          d,
          u,
          l,
          h,
          _args22 = arguments;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              t = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : {};
              o = Q(t);
              n = o.openUrl;
              a = o.fragment;
              r = o.appState;
              s = e(o, ["openUrl", "fragment", "appState"]);
              c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
              _context22.next = 9;
              return this._prepareAuthorizeUrl(s.authorizationParams || {});
            case 9:
              d = _context22.sent;
              u = d.url;
              l = e(d, ["url"]);
              this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
                appState: r
              }), c && {
                organization: c
              }));
              h = a ? "".concat(u, "#").concat(a) : u;
              if (!n) {
                _context22.next = 19;
                break;
              }
              _context22.next = 17;
              return n(h);
            case 17:
              _context22.next = 20;
              break;
            case 19:
              window.location.assign(h);
            case 20:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function loginWithRedirect() {
        return _loginWithRedirect.apply(this, arguments);
      }
      return loginWithRedirect;
    }()
  }, {
    key: "handleRedirectCallback",
    value: function () {
      var _handleRedirectCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var e,
          t,
          _ref9,
          i,
          o,
          n,
          a,
          r,
          s,
          c,
          l,
          _args23 = arguments;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              e = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : window.location.href;
              t = e.split("?").slice(1);
              if (!(0 === t.length)) {
                _context23.next = 4;
                break;
              }
              throw new Error("There are no query params available for parsing.");
            case 4:
              _ref9 = function (e) {
                e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
                var t = new URLSearchParams(e);
                return {
                  state: t.get("state"),
                  code: t.get("code") || void 0,
                  error: t.get("error") || void 0,
                  error_description: t.get("error_description") || void 0
                };
              }(t.join("")), i = _ref9.state, o = _ref9.code, n = _ref9.error, a = _ref9.error_description, r = this.transactionManager.get();
              if (r) {
                _context23.next = 7;
                break;
              }
              throw new d("missing_transaction", "Invalid state");
            case 7:
              if (!(this.transactionManager.remove(), n)) {
                _context23.next = 9;
                break;
              }
              throw new u(n, a || n, i, r.appState);
            case 9:
              if (!(!r.code_verifier || r.state && r.state !== i)) {
                _context23.next = 11;
                break;
              }
              throw new d("state_mismatch", "Invalid state");
            case 11:
              s = r.organization, c = r.nonce, l = r.redirect_uri;
              _context23.next = 14;
              return this._requestToken(Object.assign({
                audience: r.audience,
                scope: r.scope,
                code_verifier: r.code_verifier,
                grant_type: "authorization_code",
                code: o
              }, l ? {
                redirect_uri: l
              } : {}), {
                nonceIn: c,
                organization: s
              });
            case 14:
              return _context23.abrupt("return", {
                appState: r.appState
              });
            case 15:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function handleRedirectCallback() {
        return _handleRedirectCallback.apply(this, arguments);
      }
      return handleRedirectCallback;
    }()
  }, {
    key: "checkSession",
    value: function () {
      var _checkSession = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (this.cookieStorage.get(this.isAuthenticatedCookieName)) {
                _context24.next = 4;
                break;
              }
              if (this.cookieStorage.get("auth0.is.authenticated")) {
                _context24.next = 3;
                break;
              }
              return _context24.abrupt("return");
            case 3:
              this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
              }), this.cookieStorage.remove("auth0.is.authenticated");
            case 4:
              _context24.prev = 4;
              _context24.next = 7;
              return this.getTokenSilently(e);
            case 7:
              _context24.next = 11;
              break;
            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24["catch"](4);
            case 11:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[4, 9]]);
      }));
      function checkSession(_x42) {
        return _checkSession.apply(this, arguments);
      }
      return checkSession;
    }()
  }, {
    key: "getTokenSilently",
    value: function () {
      var _getTokenSilently2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this10 = this;
        var e,
          t,
          i,
          o,
          _args25 = arguments;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              e = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
              i = Object.assign(Object.assign({
                cacheMode: "on"
              }, e), {
                authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                  scope: j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
                })
              });
              _context25.next = 4;
              return function (e, t) {
                var i = A[t];
                return i || (i = e().finally(function () {
                  delete A[t], i = null;
                }), A[t] = i), i;
              }(function () {
                return _this10._getTokenSilently(i);
              }, "".concat(this.options.clientId, "::").concat(i.authorizationParams.audience, "::").concat(i.authorizationParams.scope));
            case 4:
              o = _context25.sent;
              return _context25.abrupt("return", e.detailedResponse ? o : null == o ? void 0 : o.access_token);
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function getTokenSilently() {
        return _getTokenSilently2.apply(this, arguments);
      }
      return getTokenSilently;
    }()
  }, {
    key: "_getTokenSilently",
    value: function () {
      var _getTokenSilently3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(t) {
        var i, o, _e4, _e5, _e6, _t4, n, _a, _r;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              i = t.cacheMode, o = e(t, ["cacheMode"]);
              if (!("off" !== i)) {
                _context27.next = 7;
                break;
              }
              _context27.next = 4;
              return this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
              });
            case 4:
              _e4 = _context27.sent;
              if (!_e4) {
                _context27.next = 7;
                break;
              }
              return _context27.abrupt("return", _e4);
            case 7:
              if (!("cache-only" !== i)) {
                _context27.next = 39;
                break;
              }
              _context27.next = 10;
              return function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(e) {
                  var t,
                    _i3,
                    _args26 = arguments;
                  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                    while (1) switch (_context26.prev = _context26.next) {
                      case 0:
                        t = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : 3;
                        _i3 = 0;
                      case 2:
                        if (!(_i3 < t)) {
                          _context26.next = 10;
                          break;
                        }
                        _context26.next = 5;
                        return e();
                      case 5:
                        if (!_context26.sent) {
                          _context26.next = 7;
                          break;
                        }
                        return _context26.abrupt("return", !0);
                      case 7:
                        _i3++;
                        _context26.next = 2;
                        break;
                      case 10:
                        return _context26.abrupt("return", !1);
                      case 11:
                      case "end":
                        return _context26.stop();
                    }
                  }, _callee26);
                }));
                return function (_x44) {
                  return _ref10.apply(this, arguments);
                };
              }()(function () {
                return ee.acquireLock("auth0.lock.getTokenSilently", 5e3);
              }, 10);
            case 10:
              if (_context27.sent) {
                _context27.next = 12;
                break;
              }
              throw new l();
            case 12:
              _context27.prev = 12;
              if (!(window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i)) {
                _context27.next = 19;
                break;
              }
              _context27.next = 16;
              return this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
              });
            case 16:
              _e5 = _context27.sent;
              if (!_e5) {
                _context27.next = 19;
                break;
              }
              return _context27.abrupt("return", _e5);
            case 19:
              if (!this.options.useRefreshTokens) {
                _context27.next = 25;
                break;
              }
              _context27.next = 22;
              return this._getTokenUsingRefreshToken(o);
            case 22:
              _context27.t0 = _context27.sent;
              _context27.next = 28;
              break;
            case 25:
              _context27.next = 27;
              return this._getTokenFromIFrame(o);
            case 27:
              _context27.t0 = _context27.sent;
            case 28:
              _e6 = _context27.t0;
              _t4 = _e6.id_token;
              n = _e6.access_token;
              _a = _e6.oauthTokenScope;
              _r = _e6.expires_in;
              return _context27.abrupt("return", Object.assign(Object.assign({
                id_token: _t4,
                access_token: n
              }, _a ? {
                scope: _a
              } : null), {
                expires_in: _r
              }));
            case 34:
              _context27.prev = 34;
              _context27.next = 37;
              return ee.releaseLock("auth0.lock.getTokenSilently");
            case 37:
              window.removeEventListener("pagehide", this._releaseLockOnPageHide);
              return _context27.finish(34);
            case 39:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this, [[12,, 34, 39]]);
      }));
      function _getTokenSilently(_x43) {
        return _getTokenSilently3.apply(this, arguments);
      }
      return _getTokenSilently;
    }()
  }, {
    key: "getTokenWithPopup",
    value: function () {
      var _getTokenWithPopup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var e,
          t,
          i,
          o,
          _args28 = arguments;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              e = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {};
              t = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : {};
              o = Object.assign(Object.assign({}, e), {
                authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                  scope: j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
                })
              });
              t = Object.assign(Object.assign({}, r), t);
              _context28.next = 6;
              return this.loginWithPopup(o, t);
            case 6:
              _context28.next = 8;
              return this.cacheManager.get(new C({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
              }));
            case 8:
              return _context28.abrupt("return", _context28.sent.access_token);
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function getTokenWithPopup() {
        return _getTokenWithPopup.apply(this, arguments);
      }
      return getTokenWithPopup;
    }()
  }, {
    key: "isAuthenticated",
    value: function () {
      var _isAuthenticated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return this.getUser();
            case 2:
              return _context29.abrupt("return", !!_context29.sent);
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function isAuthenticated() {
        return _isAuthenticated.apply(this, arguments);
      }
      return isAuthenticated;
    }()
  }, {
    key: "_buildLogoutUrl",
    value: function _buildLogoutUrl(t) {
      null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
      var i = t.logoutParams || {},
        o = i.federated,
        n = e(i, ["federated"]),
        a = o ? "&federated" : "";
      return this._url("/v2/logout?".concat(v(Object.assign({
        clientId: t.clientId
      }, n)))) + a;
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var t,
          i,
          o,
          n,
          a,
          _args30 = arguments;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              t = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : {};
              i = Q(t), o = i.openUrl, n = e(i, ["openUrl"]);
              if (!(null === t.clientId)) {
                _context30.next = 7;
                break;
              }
              _context30.next = 5;
              return this.cacheManager.clear();
            case 5:
              _context30.next = 9;
              break;
            case 7:
              _context30.next = 9;
              return this.cacheManager.clear(t.clientId || this.options.clientId);
            case 9:
              this.cookieStorage.remove(this.orgHintCookieName, {
                cookieDomain: this.options.cookieDomain
              });
              this.cookieStorage.remove(this.isAuthenticatedCookieName, {
                cookieDomain: this.options.cookieDomain
              });
              this.userCache.remove("@@user@@");
              a = this._buildLogoutUrl(n);
              if (!o) {
                _context30.next = 18;
                break;
              }
              _context30.next = 16;
              return o(a);
            case 16:
              _context30.next = 19;
              break;
            case 18:
              !1 !== o && window.location.assign(a);
            case 19:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "_getTokenFromIFrame",
    value: function () {
      var _getTokenFromIFrame2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(e) {
        var t, i, _yield$this$_prepareA, o, n, a, r, s, c, u, _i4, _h, _p;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              t = Object.assign(Object.assign({}, e.authorizationParams), {
                prompt: "none"
              }), i = this.cookieStorage.get(this.orgHintCookieName);
              i && !t.organization && (t.organization = i);
              _context31.next = 4;
              return this._prepareAuthorizeUrl(t, {
                response_mode: "web_message"
              }, window.location.origin);
            case 4:
              _yield$this$_prepareA = _context31.sent;
              o = _yield$this$_prepareA.url;
              n = _yield$this$_prepareA.state;
              a = _yield$this$_prepareA.nonce;
              r = _yield$this$_prepareA.code_verifier;
              s = _yield$this$_prepareA.redirect_uri;
              c = _yield$this$_prepareA.scope;
              u = _yield$this$_prepareA.audience;
              _context31.prev = 12;
              if (!window.crossOriginIsolated) {
                _context31.next = 15;
                break;
              }
              throw new d("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            case 15:
              _i4 = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
              _context31.next = 18;
              return function (e, t) {
                var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
                return new Promise(function (o, n) {
                  var a = window.document.createElement("iframe");
                  a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                  var r = function r() {
                    window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                  };
                  var s;
                  var c = setTimeout(function () {
                    n(new l()), r();
                  }, 1e3 * i);
                  s = function (_s) {
                    function s(_x46) {
                      return _s.apply(this, arguments);
                    }
                    s.toString = function () {
                      return _s.toString();
                    };
                    return s;
                  }(function (e) {
                    if (e.origin != t) return;
                    if (!e.data || "authorization_response" !== e.data.type) return;
                    var i = e.source;
                    i && i.close(), e.data.response.error ? n(d.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                  }), window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                });
              }(o, this.domainUrl, _i4);
            case 18:
              _h = _context31.sent;
              if (!(n !== _h.state)) {
                _context31.next = 21;
                break;
              }
              throw new d("state_mismatch", "Invalid state");
            case 21:
              _context31.next = 23;
              return this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: _h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
              }), {
                nonceIn: a,
                organization: t.organization
              });
            case 23:
              _p = _context31.sent;
              return _context31.abrupt("return", Object.assign(Object.assign({}, _p), {
                scope: c,
                oauthTokenScope: _p.scope,
                audience: u
              }));
            case 27:
              _context31.prev = 27;
              _context31.t0 = _context31["catch"](12);
              throw "login_required" === _context31.t0.error && this.logout({
                openUrl: !1
              }), _context31.t0;
            case 30:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this, [[12, 27]]);
      }));
      function _getTokenFromIFrame(_x45) {
        return _getTokenFromIFrame2.apply(this, arguments);
      }
      return _getTokenFromIFrame;
    }()
  }, {
    key: "_getTokenUsingRefreshToken",
    value: function () {
      var _getTokenUsingRefreshToken2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(e) {
        var t, i, o, n;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return this.cacheManager.get(new C({
                scope: e.authorizationParams.scope,
                audience: e.authorizationParams.audience || "default",
                clientId: this.options.clientId
              }));
            case 2:
              t = _context32.sent;
              if (t && t.refresh_token || this.worker) {
                _context32.next = 9;
                break;
              }
              if (!this.options.useRefreshTokensFallback) {
                _context32.next = 8;
                break;
              }
              _context32.next = 7;
              return this._getTokenFromIFrame(e);
            case 7:
              return _context32.abrupt("return", _context32.sent);
            case 8:
              throw new f(e.authorizationParams.audience || "default", e.authorizationParams.scope);
            case 9:
              i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
              _context32.prev = 10;
              _context32.next = 13;
              return this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
              }), o && {
                timeout: o
              }));
            case 13:
              n = _context32.sent;
              return _context32.abrupt("return", Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
              }));
            case 17:
              _context32.prev = 17;
              _context32.t0 = _context32["catch"](10);
              if (!((_context32.t0.message.indexOf("Missing Refresh Token") > -1 || _context32.t0.message && _context32.t0.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback)) {
                _context32.next = 23;
                break;
              }
              _context32.next = 22;
              return this._getTokenFromIFrame(e);
            case 22:
              return _context32.abrupt("return", _context32.sent);
            case 23:
              throw _context32.t0;
            case 24:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this, [[10, 17]]);
      }));
      function _getTokenUsingRefreshToken(_x47) {
        return _getTokenUsingRefreshToken2.apply(this, arguments);
      }
      return _getTokenUsingRefreshToken;
    }()
  }, {
    key: "_saveEntryInCache",
    value: function () {
      var _saveEntryInCache2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(t) {
        var i, o, n;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              i = t.id_token, o = t.decodedToken, n = e(t, ["id_token", "decodedToken"]);
              this.userCache.set("@@user@@", {
                id_token: i,
                decodedToken: o
              });
              _context33.next = 4;
              return this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken);
            case 4:
              _context33.next = 6;
              return this.cacheManager.set(n);
            case 6:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function _saveEntryInCache(_x48) {
        return _saveEntryInCache2.apply(this, arguments);
      }
      return _saveEntryInCache;
    }()
  }, {
    key: "_getIdTokenFromCache",
    value: function () {
      var _getIdTokenFromCache2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var e, t, i;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              e = this.options.authorizationParams.audience || "default";
              _context34.next = 3;
              return this.cacheManager.getIdToken(new C({
                clientId: this.options.clientId,
                audience: e,
                scope: this.scope
              }));
            case 3:
              t = _context34.sent;
              i = this.userCache.get("@@user@@");
              return _context34.abrupt("return", t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t));
            case 6:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function _getIdTokenFromCache() {
        return _getIdTokenFromCache2.apply(this, arguments);
      }
      return _getIdTokenFromCache;
    }()
  }, {
    key: "_getEntryFromCache",
    value: function () {
      var _getEntryFromCache2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(_ref11) {
        var e, t, i, o, _e7, _t5, _i5, n;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              e = _ref11.scope, t = _ref11.audience, i = _ref11.clientId;
              _context35.next = 3;
              return this.cacheManager.get(new C({
                scope: e,
                audience: t,
                clientId: i
              }), 60);
            case 3:
              o = _context35.sent;
              if (!(o && o.access_token)) {
                _context35.next = 12;
                break;
              }
              _e7 = o.access_token;
              _t5 = o.oauthTokenScope;
              _i5 = o.expires_in;
              _context35.next = 10;
              return this._getIdTokenFromCache();
            case 10:
              n = _context35.sent;
              return _context35.abrupt("return", n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: _e7
              }, _t5 ? {
                scope: _t5
              } : null), {
                expires_in: _i5
              }));
            case 12:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function _getEntryFromCache(_x49) {
        return _getEntryFromCache2.apply(this, arguments);
      }
      return _getEntryFromCache;
    }()
  }, {
    key: "_requestToken",
    value: function () {
      var _requestToken2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(e, t) {
        var _ref12, i, o, n, a;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _ref12 = t || {};
              i = _ref12.nonceIn;
              o = _ref12.organization;
              _context36.next = 5;
              return T(Object.assign({
                baseUrl: this.domainUrl,
                client_id: this.options.clientId,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs
              }, e), this.worker);
            case 5:
              n = _context36.sent;
              _context36.next = 8;
              return this._verifyIdToken(n.id_token, i, o);
            case 8:
              a = _context36.sent;
              _context36.next = 11;
              return this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
                decodedToken: a,
                scope: e.scope,
                audience: e.audience || "default"
              }), n.scope ? {
                oauthTokenScope: n.scope
              } : null), {
                client_id: this.options.clientId
              }));
            case 11:
              this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
              });
              this._processOrgHint(o || a.claims.org_id);
              return _context36.abrupt("return", Object.assign(Object.assign({}, n), {
                decodedToken: a
              }));
            case 14:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function _requestToken(_x50, _x51) {
        return _requestToken2.apply(this, arguments);
      }
      return _requestToken;
    }()
  }]);
}();
var ie = /*#__PURE__*/_createClass(function ie() {
  _classCallCheck(this, ie);
});
function oe(_x52) {
  return _oe.apply(this, arguments);
}
function _oe() {
  _oe = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(e) {
    var t;
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          t = new te(e);
          _context39.next = 3;
          return t.checkSession();
        case 3:
          return _context39.abrupt("return", t);
        case 4:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _oe.apply(this, arguments);
}
export { te as Auth0Client, u as AuthenticationError, C as CacheKey, d as GenericError, P as InMemoryCache, z as LocalStorageCache, m as MfaRequiredError, f as MissingRefreshTokenError, p as PopupCancelledError, h as PopupTimeoutError, l as TimeoutError, ie as User, oe as createAuth0Client };